<template>
  <div class="price blue secondary-font">
    $ {{totalPrice.toFixed(2)}}
  </div><!-- /.price -->
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Price",
  data: function() {
    return {
      totalPrice: 0,
    };
  },
  computed: {
    ...mapState(["selectedOptions"])
  },
  created() {
    this.calculatePrice(this.selectedOptions);
  },
  methods: {
    calculatePrice(options) {
      let prices = [];
      let optionsArr = Object.values(options); // obj to arr
      for (let option of optionsArr) {
        // If it has a price and isn't a design option, or if it is a selected design option, count the price toward total price
        if (
          (!option.isDesignOption && option.price) ||
          (option.isDesignOption && option.name && option.price)
        ) {
          prices.push(option.price);
        }
      }
      let total = 0;
      for (let price of prices) {
        total += price;
      }
      this.totalPrice = total;
    }
  },
  watch: {
    selectedOptions: {
      handler: function(options) {
        this.calculatePrice(options);
      },
      deep: true
    }
  }
}
</script>
